import { useState } from 'react'
import { styled } from '@mui/material/styles'
import useSnackbarStore from '../../stores/useSnackbarStore'
import useLayout from '../../hooks/backoffice/useLayout'
import Snackbar from '../../control/Snackbar'
import Menu from './CoreMenu'

type BackofficeLayoutViewType = ReturnType<typeof useLayout>

const LayoutView: React.FC<BackofficeLayoutViewType> = ({ children }) => {
    const snackbarStore = useSnackbarStore()
    const [isOpen, setIsOpen] = useState<boolean>(snackbarStore.isOpen)

    return (
        <Root>
            <Container>
                <StyledDivMenu>
                    <Menu />
                </StyledDivMenu>
                <StyledDivContent>
                    <StyledDivBoxContent>{children}</StyledDivBoxContent>
                </StyledDivContent>
            </Container>
            <Snackbar
                type="error"
                message={'Session expired'}
                isOpen={isOpen}
                autoHideDuration={snackbarStore.openDuration}
                onClose={() => {
                    setIsOpen(false)
                    snackbarStore.setOpenSnackbar(false)
                }}
                position={{ vertical: 'bottom', horizontal: 'left' }}
            />
        </Root>
    )
}

const Layout: React.FC = ({ children }) => {
    const model = useLayout()
    return <LayoutView children={children} {...model} />
}

const Root = styled('div')(({ theme }) => ({
    width: '100%',
    height: '100%',
    display: 'inline-table',
}))

const Container = styled('div')(({ theme }) => ({
    display: 'flex',
    margin: '20px 100px 10px 100px',
    [theme.breakpoints.down('md')]: {
        margin: '20px',
    },
}))

const StyledDivMenu = styled('div')(({ theme }) => ({
    width: '240px',
    marginRight: '10px',
}))

const StyledDivContent = styled('div')(({ theme }) => ({
    width: 'calc(100% - 240px)',
    marginLeft: '10px',
}))

const StyledDivBoxContent = styled('div')(({ theme }) => ({
    marginRight: '60px',
}))

export default Layout
